import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormField } from '@app/shared/models/dynamic-form.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-dynamic-form-field',
    templateUrl: './dynamic-form-field.component.html',
    styleUrls: ['./dynamic-form-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DynamicFormFieldComponent implements OnInit, OnDestroy {
    @Input() form!: FormGroup;
    @Input() field!: DynamicFormField;
    @Output() valueChange: EventEmitter<unknown> = new EventEmitter<unknown>();

    private currentValue: unknown;
    private destroy$ = new Subject<void>();

    get isValid() {
        return this.form.controls[this.field.key].valid;
    }

    get errorMessage() {
        let message = '';

        this.field.validation.forEach((validator) => {
            if (this.form.controls[this.field.key].hasError(validator.key)) {
                message = validator.errorMessage;
                return;
            }
        });

        return message;
    }

    ngOnInit() {
        this.currentValue = this.field.value;
        this.form.controls[this.field.key].valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (this.currentValue !== value) {
                    this.currentValue = value;
                    this.valueChange.emit(value);
                }
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
